import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import aylaLogo from './ayla-logo.png';
import { MdHome, MdCheckroom, MdEmail, MdExitToApp, MdStore } from 'react-icons/md';
import { auth } from './firebase';

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/dashboard" className="nav-icon"><MdHome /></Link>
        <Link to="/garments" className="nav-icon"><MdCheckroom /></Link>
        <a href="https://aylaarchives.com/collections/all" target="_blank" rel="noopener noreferrer" className="nav-icon">
          <MdStore />
        </a>
      </div>
      <div className="navbar-center">
        <Link to="/dashboard">
          <img src={aylaLogo} alt="Ayla" className="navbar-logo" />
        </Link>
      </div>
      <div className="navbar-right">
        <Link to="/chat" className="nav-icon"><MdEmail /></Link>
        <button onClick={handleLogout} className="nav-icon logout-button">
          <MdExitToApp />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
